import Search from "components/search/search";
import SearchInput from "components/search/searchInput";
import { useDebounce, useSearchEventsAndCategories } from "hooks";
import { useState } from "react";
import SearchIcon from "../Icons/SearchIcon";
import CloseIcon from "../Icons/CloseIcon";
import SideMenu from "./sidemenu";

const Navbar = () => {
  const [search, setSearch] = useState("");
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const debouncedSearchQuery = useDebounce(search, 600);
  const { data: searchResults } =
    useSearchEventsAndCategories(debouncedSearchQuery);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  return (
    <nav
      className={` flex justify-between items-center w-full flex-wrap absolute top-0  z-20
        } `}
      aria-label="Main"
    >
      <div
        className={`flex justify-between items-center w-full ${
          (search.length > 0 || isMobileSearchOpen) && "absolute top-0 z-20"
        }`}
      >
        <SideMenu />
        <div className="pt-10 pr-11 phone-100:pt-6 phone-100:hidden">
          <SearchInput
            handleSearch={handleSearch}
            search={search}
            setSearch={setSearch}
          />
        </div>
        <button
          role="button"
          className="hidden phone-100:block pr-5 pt-4"
          onClick={() => {
            setIsMobileSearchOpen(!isMobileSearchOpen);
            setSearch("");
          }}
        >
          {!isMobileSearchOpen ? <SearchIcon /> : <CloseIcon />}
        </button>
      </div>
      <Search
        setSearch={setSearch}
        results={searchResults}
        search={debouncedSearchQuery}
        isMobileSearchOpen={isMobileSearchOpen}
        handleSearch={handleSearch}
      />
    </nav>
  );
};

export default Navbar;
